import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import NewConsultant from "./NewConsultation";
import styled from "styled-components";
import { CustomLinkBut, CustomBTNDIV } from "../../style/Dashboard";
import { verifyAuth } from "../../authverify";
import { useHistory } from "react-router-dom";

const GirdContainer = styled.div`
  display: grid;
  grid-template-columns: 20% 80%;
  height: 50px;
  @media (max-width: 906px) {
    grid-template-columns: 1fr;
  }
`;
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;
const useStyles = makeStyles((theme) => ({
  root: {},

  button: {
    backgroundColor: "#03b3fb",
    borderRadius: 20,
    display: "flex",
    border: "1px solid #c5c5c5",
    float: "right",
    color: "white",
    fontWeight: "bold",
    fontFamily: "helvetica",
    textTransform: "none",
    width: 1000,
    height: 30,
    fontSize: 15,
    margin: 4,
    "&:hover": {
      backgroundColor: "#0389fb",
    },
  },
}));

export default function Consultation({ selectedBanner, setSelectedBanner, reactCreative }) {
  const classes = useStyles();
  const history = useHistory();

  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }

  return (
    <div style={{ width: "95%" }}>
      <GirdContainer>
        <div>
          <Paper
            style={{
              color: "#4678ED",
              fontWeight: 600,
              maxWidth: "100%",
              width: "100%",
              fontSize: "15.5px",
              fontFamily:
                "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
            }}
          >
            New Consultation
          </Paper>
          <Paper
            style={{
              fontWeight: 600,
              maxWidth: "100%",
              width: "100%",
              color: "#606060",
              fontSize: "15.5px",
              fontFamily:
                "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
            }}
          >
            Consultation history
          </Paper>
          <div className="bannerAd" style={{ marginTop: "20px",width:"309px" }}>
            <iframe
              style={{ height: "300px", width: "100%" }}
              srcDoc={reactCreative}
            />
          </div>
        </div>
        <div style={{ paddingLeft: 15 }}>
          <NewConsultant
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
          />
        </div>
      </GirdContainer>
      <CustomBTNDIV>
        <CustomLinkBut className="button" to="/People/Procedures">
          Next
        </CustomLinkBut>
      </CustomBTNDIV>
    </div>
  );
}

{
  /* <Grid item xs={3}>
                
                </Grid>
                <Grid item xs={9}>
                  
                </Grid>
                <Grid item xs={12}>
                  <Button className={classes.button}>Next</Button>
                </Grid> */
}
